import { ShopPillarCard } from './pillars/ShopPillarCard.jsx';
import { AlwisPillarCard } from './pillars/AlwisPillarCard.jsx';
import { RagPillarCard } from './pillars/RagPillarCard.jsx';
import { 
  TOTAL_SKU_COUNT, 
  ACTIVE_TENANTS, 
  PRICE_CATALOG_SYNC, 
  ALWIS_CORE_CAPABILITIES, 
  SECURITY_COMPLIANCE, 
  TOTAL_MASTER_DOCS, 
  TOTAL_PAGES, 
  TOTAL_CHUNKS, 
  TOTAL_SKU_LINKS 
} from './executive-data.js';
import { cn } from '../../lib/utils.js';

export function ExecutivePillars({
  onNavigateTab,
  onOpenCopilot,
  onOpenUpload,
  onNavigate,
  skuCount = TOTAL_SKU_COUNT,
  tenants = ACTIVE_TENANTS,
  catalogTimestamp = PRICE_CATALOG_SYNC.formattedDate,
  docCount = TOTAL_MASTER_DOCS,
  pageCount = TOTAL_PAGES,
  chunkCount = TOTAL_CHUNKS,
  skuLinkCount = TOTAL_SKU_LINKS,
  className,
}) {
  return (
    <section className={cn('space-y-4', className)} aria-label="Die 3 Plattform-Säulen">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-display text-lg sm:text-xl font-extrabold text-[var(--foreground,#181716)]">
            Die 3 Plattform-Säulen im Überblick
          </h2>
          <p className="text-xs sm:text-sm text-[var(--secondary,#475569)] mt-0.5">
            Modulare B2B-Architektur für Großhandels-Handel, KI-Produktberatung und technisches Fach-RAG
          </p>
        </div>
      </div>

      <div 
        data-testid="executive-pillars-grid"
        className="grid grid-cols-1 gap-6 lg:grid-cols-3"
      >
        {/* Pillar 1: White-Label Shop */}
        <ShopPillarCard
          skuCount={skuCount}
          tenants={tenants}
          catalogTimestamp={catalogTimestamp}
          onNavigate={onNavigate}
          onOpenTab={onNavigateTab}
        />

        {/* Pillar 2: ALWIS Produktberater */}
        <AlwisPillarCard
          capabilities={ALWIS_CORE_CAPABILITIES}
          zeroAudioRetention={SECURITY_COMPLIANCE.zeroAudioRetention}
          onOpenCopilot={onOpenCopilot}
          onOpenTab={onNavigateTab}
        />

        {/* Pillar 3: RAG Wissensdatenbank */}
        <RagPillarCard
          docCount={docCount}
          pageCount={pageCount}
          chunkCount={chunkCount}
          skuLinkCount={skuLinkCount}
          onOpenUpload={onOpenUpload || (() => onNavigateTab && onNavigateTab('rag'))}
          onOpenTab={onNavigateTab}
        />
      </div>
    </section>
  );
}
